
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.675 6.5v-6H18v6h-5.325zm-6.325 0v-6h5.325v6H6.35zm-6.325 0v-6H5.35v6H.025zm0 7v-6H5.35v6H.025zm6.325 0v-6h5.325v6H6.35zm6.325 0v-6H18v6h-5.325z"}})])
          )
        }
      }
    